export const RAGSTATUS_AMBER_FROMINTERVAL = 'RagStatusAmberFromInterval';
export const RAGSTATUS_RED_FROMINTERVAL = 'RagStatusRedFromInterval';

export const RAGSTATUS_AMBER_FROMINTERVAL_DEFAULT = '0.25';
export const RAGSTATUS_RED_FROMINTERVAL_DEFAULT = '0.75';

export const OVERRIDE_CLINICIANS_COUNT = 7;

export const SCHEDULER_DAYMODE_STARTTIME = 'SchedulerDayModeStartTime';
export const SCHEDULER_NIGHTMODE_STARTTIME = 'SchedulerNightModeStartTime';

export const ENABLE_MILEAGE_CAP = 'EnableMileageCap';
export const ENABLE_MILEAGE_CAP_DEFAULT = false;

export const ENABLE_RECORDING_OF_WEEKLY_REQUESTED_DAYS = 'EnableRecordingOfWeeklyRequestedDays';

export const ENABLE_SETTING_PATIENTS_AS_INACTIVE = 'EnableSettingPatientsAsInactive';

export const ENABLE_SENDING_REQUEST_LOGS_TO_RIO = 'EnableSendingRequestLogsToRio';

export const ENABLE_MAPPING_OF_TEAMS = 'EnableMappingOfTeams';
